import MarkdownIt from "markdown-it";

const md = MarkdownIt({ breaks: true });
const mila = require("markdown-it-link-attributes");
md.use(mila, {
    attrs: {
        target: "_blank",
        rel: "noopener",
    },
});
export default md;